import React from "react";
import {createUseStyles} from "react-jss";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import {
	LeaderboardContentSize,
	LeaderboardContentSizeCompact,
	LeaderboardRowHeight,
	LeaderboardRowHeightCompact
} from "../accessory/accessoryConstants";
import {Theme} from "engage-client/theme";

const useStyles = createUseStyles<Theme>((theme) => ({
	score: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		margin: props => (props.rowHeight - props.height)/2,
		height: props => props.height,
		width: 70,
		...theme.accessoryPanel.leaderboard.scorePill.showBorder ? {
			borderRadius: props => props.contentSize / 2,
			borderWidth: props => props.scoreBorderWidth,
			borderColor: props => props.color,
			borderStyle: "solid"} : {},
		backgroundColor: props => props.highlighted ? "transparent" : props.color,

	}
}));

export type ScorePillProps = {
	color: string
	fontWeight?: number
	highlighted: boolean
	score: number
	compact: boolean
}

export default function ScorePill(props:ScorePillProps) {
	// eslint-disable-next-line @typescript-eslint/no-extra-parens
	const scoreBorderWidth = props.highlighted ? (props.compact ? 2 : 3) : 0;
	const contentSize = props.compact ? LeaderboardContentSizeCompact : LeaderboardContentSize;
	const rowHeight = props.compact ? LeaderboardRowHeightCompact : LeaderboardRowHeight;
	const height = contentSize - 4;
	const classes = useStyles({...props, scoreBorderWidth, height, rowHeight, contentSize});

	return <DisplayText variant={TextVariant.s18med} className={classes.score} align="center" fontWeight={props.fontWeight}>
		{props.score.toFixed(0)}
	</DisplayText>;
};
